// extracted by mini-css-extract-plugin
export default {"gameDetailsContainer":"KFU3AJ2K5kEpaBP_vtzI","lobbyWaitContainer":"HX_Sdl0fBw_ViNGs3gjc","textsContainer":"miNE2SLxc7InLAPwrpbO"};